import Tab from "components/Tab";
import UploadSourceMapPlatforms from "../../../../contents/docs/error-tracking/upload-source-maps/_snippets/upload-source-map-platforms.tsx";
import * as React from 'react';
export default {
  Tab,
  UploadSourceMapPlatforms,
  React
};